// src/pages/Dashboard.tsx
import {
  Badge,
  Box,
  Button,
  Text,
  Card,
  Flex,
  Heading,
} from "@radix-ui/themes";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { Manuals } from "../utils/constants";
import { getBlob } from "../utils/axios-config";
import { useExportDocument } from "../hooks/useExportDocument";
import toast from "react-hot-toast";
import { size } from "lodash";
import { DownloadIcon } from "@radix-ui/react-icons";

const Dashboard: React.FC = () => {
  const userData = useSelector((state: RootState) => state.login.userData);
  const { downloadOnly } = useExportDocument();

  const getManualType = () => {
    const rawRole = userData?.Role;
    const role = Array.isArray(rawRole) ? rawRole[0] ?? "" : rawRole ?? "";
    const normalized = String(role).toLowerCase();

    if (normalized === "administrador" || normalized === "admin") {
      return "manual-administrador";
    }
    if (normalized === "docente") {
      return "manual-docente";
    }
    if (normalized === "estudante") {
      return "manual-usuario";
    }
    return undefined;
  };
  const manualType = getManualType();
  if (!manualType) {
       
      
    return null;
  };
  const handleDownload = async () => {
    if (!manualType) return;
    try {
      const blob = await getBlob(`${Manuals}/${manualType}`);
      const fileName = `${manualType}.pdf`;
      await downloadOnly(blob, fileName);
      toast.success("Manual descarregado com sucesso.");
    } catch (error: any) {
      console.error("Erro ao descarregar o manual:", error);
      toast.error("Erro ao descarregar o manual. Por favor, tente novamente.");
    }
  };

  // const renderDownloadButton = () => {
  //   if (!manualType) {
  //     return null!;
  //   }
  //   return (
  //     <Button onClick={handleDownload} variant="solid" size="2">
  //       Descarregar Manual do {userData?.Role}
  //     </Button>
  //   );
  // };
  return (
    <Box width="100%" height="88%" p="4">
      <Card
        variant="classic"
        size="4"
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "3rem",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          borderRadius: "16px",
        }}
      >
        <Flex direction="column" align="center" gap="4" maxWidth="600px">
          <Flex align="center" gap="3">
            <Heading as="h2" size="6" weight="bold">
              Manual de Uso
            </Heading>
            <Badge color="green" size="2" variant="solid">
              Novo
            </Badge>
          </Flex>

          <Text size="3" color="gray">
            Consulte o guia completo com instruções detalhadas sobre como
            utilizar a plataforma e tirar o máximo proveito das funcionalidades.
          </Text>

          <Button
            type="button"
            onClick={handleDownload}
            variant="outline"
          >
            <DownloadIcon /> Descarregar
          </Button>
        </Flex>
      </Card>
    </Box>
  );
};

export default Dashboard;
